/**
 * Type corresponding to something or its Promise
 */
export type PromiseOrNot<T> = Promise<T> | T;

/**
 * Determine if it is the promise of something
 */
export function isPromise<T>(promiseOrNot: PromiseOrNot<T>): promiseOrNot is Promise<T> {
    return !!promiseOrNot && (promiseOrNot as Promise<T>).catch != null;
}

/**
 * Convert something to promise if needed
 */
export function asPromise<T>(promiseOrNot: PromiseOrNot<T>): Promise<T> {
    return isPromise(promiseOrNot) ? promiseOrNot : Promise.resolve(promiseOrNot);
}

/** Promisified version of setTimeout (compatible with client/server) */
export function wait(ms: number): Promise<void> {
    return new Promise<void>((resolve) => {
        setTimeout(resolve, ms);
    });
}